import { Box } from '@mui/material';
import React, { useEffect, useState, useCallback } from 'react';

const ButtonDownloadPWA = (props) => {
  const [isReadyForInstall, setIsReadyForInstall] = useState(false);

  useEffect(() => {
    const handleBeforeInstallPrompt = (event) => {
      // Prevent the mini-infobar from appearing on mobile.
      event.preventDefault();
      // Stash the event so it can be triggered later.
      window.deferredPrompt = event;
      // Show the install button.
      setIsReadyForInstall(true);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    // Cleanup: Remove listener on unmount
    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const downloadApp = useCallback(async () => {
    try {
      const promptEvent = window.deferredPrompt;
      if (!promptEvent) {
        console.info('beforeinstallprompt no disponible');
        return;
      }

      // Show the install prompt
      promptEvent.prompt();

      // Wait for user choice
      const result = await promptEvent.userChoice;

      if (result.outcome === 'accepted') {
        console.log('✅ App instalada correctamente');
      } else if (result.outcome === 'dismissed') {
        console.log('❌ Instalación rechazada por el usuario');
      }

      // Reset the deferred prompt variable, since prompt() can only be called once
      window.deferredPrompt = null;
      setIsReadyForInstall(false);
    } catch (error) {
      console.error('Error al instalar la app:', error);
    }
  }, []);

  // Only render if ready for install
  if (!isReadyForInstall) {
    return null;
  }

  if (props.children) {
    return (
      <Box onClick={downloadApp} sx={{ cursor: 'pointer' }}>
        {props.children}
      </Box>
    );
  }

  return (
    <button onClick={downloadApp} style={{ cursor: 'pointer' }}>
      Descargar App
    </button>
  );
};

export default ButtonDownloadPWA;
